<template>
  <div class="section-about" data-aos="fade-up" data-aos-once="true">
    <div-container>
      <div class="columns is-gapless is-centered is-vcentered">
        <div class="column is-4 has-text-centered aplayer-wrapper">
          <vue-aplayer
            id="aplayer" v-if="music && !disabled"
            :element="music.element"
            :narrow="music.narrow"
            :autoplay="music.autoplay"
            :mode="'single'"
            :music="music"
            ref="aplayer">
          </vue-aplayer>
          <img v-else :src="imageUrl" width="350" style="max-width:100%;padding:5px;" />
        </div>
        <div class="column is-7 has-text-left" v-html="paragraph.content" />
      </div>
      <!-- <div class="control notification is-danger" v-if="error">
        <button class="delete" @click="error = undefined"></button>
        <p v-html="error">
        </p>
      </div> -->
    </div-container>
  </div>
</template>

<script>
import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
import ShowDown from 'showdown'
import VueAplayer from 'vue-aplayer'
// import RadioFile from '@/assets/radio-2019.mp3'
// import RadioFile from '@/assets/radio-2021.mp3'
// import RadioFile from '@/assets/radio-2022.mp3'

export default {
  name: 'about',
  components: {
    DivContainer,
    VueAplayer
  },
  data () {
    return {
      paragraph: {
        title: '',
        content: ''
      },
      music: undefined,
      imageUrl: undefined,
      error: undefined,
      loading: false,
      disabled: true
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    getItems: function (onComplete) {
      this.loading = true
      this.error = undefined
      this.paragraph.content = ''
      this.paragraph.title = ''
      Site.aboutWithName('bosshog::about-main')
      .then((data) => {
        this.loading = false
        // console.log(data)
        if (!data || !data.content) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        var converter = new ShowDown.Converter()
        var html = converter.makeHtml(data.content)
        this.paragraph.content = html
        this.paragraph.title = data.title
        this.imageUrl = data.image.path

        var element = document.getElementById('aplayer')
        if (data.file && data.file.path) {
          this.music = {
            element: element,
            narrow: true,
            autoplay: false,
            mode: 'single',
            title: 'Boss Hog Radio',
            author: 'Boss Hog Cook-Off',
            url: data.file.path,
            pic: this.imageUrl,
            lrc: '[00:00.00]lrc here\n[00:01.00]aplayer'
          }
        } else {
          this.music = undefined
        }
        this.disabled = data.disabled
        this.$nextTick(function () {
          this.music.autoplay = false
          // console.log('-- $refs')
          // console.log(this.$refs.aplayer)
          if (this.$refs.aplayer) {
            // var player = this.$refs.aplayer
            // player.$set('mode', 'single')
            // if (player.control) {
            //   player.control.mode = 'single'
            // }
            // player.play()
          }
        })

        if (onComplete) {
          onComplete(data)
        }
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },
    refresh: function () {
      this.getItems((item) => {
        // this.item = item
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section about

.section-about {
  background-color: $color-beige;
  padding-top: 3rem;
  padding-bottom: 3rem;

  .title:not(:last-child),
  .subtitle:not(:last-child) {
    padding-left: 0.75em;
    padding-right: 0.75em;
    margin-bottom: 0.1em;
  }

  .title:last-child,
  .subtitle:last-child {
    padding-left: 0.75em;
    padding-right: 0.75em;
    margin-bottom: 1em;
  }

  p {
    color: $color-darkbrown;
    font-size: 1em;
    line-height: 2.2em;
    text-align: left;
    padding-left: 0.75em;
    padding-right: 0.75em;

    &:not(:first-child) {
      margin-top: 1em;
      @media screen and (min-width: $tablet) {
        margin-top: 1em;
      }
    }
  }

  .columns.is-gapless > .column {
    &.aplayer-wrapper {
      padding: 30px;
    }
  }

  .aplayer {
    width: 100%;
    box-shadow: 0 0 0 0, 0 0 0 0, 0 0 0 0;
    overflow: visible;
    position: relative;

    &.aplayer-narrow {
      width: 100%;
    }

    .aplayer-pic {
      width: 100%;
      padding-top: 75%;
      background-color: #f8ece9 !important;
      background-repeat: no-repeat;
      position: relative;

      @media screen and (min-width: $mobile) {
        padding-top: 85%;
      }

      @media screen and (min-width: $tablet) {
        padding-top: 65%;
      }

      @media screen and (min-width: $desktop) {
        padding-top: 65%;
      }

      @media screen and (min-width: $fullhd) {
        padding-top: 75%;
      }

      .aplayer-button {
        text-shadow: 0 1px 1px rgba(0, 0, 0, 0);
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0);
        background: rgba(0, 0, 0, 0)
      }

      .aplayer-play, .aplayer-pause {
        width: 95%;
        height: 95%;
        border: 0;
        top: 0%;
        right: 50%;
        margin: 0 -45% -50% 0;
        padding: 0px;

        .aplayer-icon-play, .aplayer-icon-pause {
          top: 30%;
          left: 30%;
          width: 40%;
          height: 40%;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// AboutSection.vue?9b668cf2